(function () {
  'use strict';

  // Parse strap data from the JSON script tag
  var dataEl = document.getElementById('strap-data');
  if (!dataEl) return;

  var strapData;
  try {
    strapData = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!strapData || !strapData.length) return;

  // State
  var selectedStrapProductId = null;
  var selectedStrapVariantId = null;

  // DOM refs
  var selectorRoot = document.getElementById('strap-selector');
  var errorEl = document.getElementById('strap-selector-error');
  var sectionEl = selectorRoot ? selectorRoot.closest('.shopify-section') : null;

  // Find the product-form-component
  var productFormComponent = sectionEl
    ? sectionEl.querySelector('product-form-component')
    : document.querySelector('product-form-component');

  if (!productFormComponent) return;

  // Save reference to the original handleSubmit
  var originalHandleSubmit = productFormComponent.handleSubmit.bind(productFormComponent);

  // --- ATC Button helpers ---

  function getMainAtcButton() {
    if (!productFormComponent) return null;
    var container = productFormComponent.querySelector('add-to-cart-component');
    return container ? container.querySelector('[ref="addToCartButton"]') : null;
  }

  function getStickyAtcComponent() {
    return sectionEl ? sectionEl.querySelector('sticky-add-to-cart') : null;
  }

  function getStickyAtcButton() {
    var sticky = getStickyAtcComponent();
    return sticky ? sticky.querySelector('[ref="addToCartButton"]') : null;
  }

  function getMainAtcTextElement(btn) {
    if (!btn) return null;
    return btn.querySelector('.add-to-cart-text__content span span');
  }

  function disableAtcButton(message) {
    var btn = getMainAtcButton();
    if (!btn) return;
    btn.disabled = true;
    var textEl = getMainAtcTextElement(btn);
    if (textEl && message) {
      textEl.textContent = message;
    }
  }

  function enableAtcButton() {
    var btn = getMainAtcButton();
    if (!btn) return;
    btn.disabled = false;
    var textEl = getMainAtcTextElement(btn);
    if (textEl) {
      textEl.textContent = 'Add to cart';
    }
  }

  function disableStickyAtcButton(message) {
    var btn = getStickyAtcButton();
    if (!btn) return;
    btn.disabled = true;
    var textEl = btn.querySelector('.add-to-cart-text__content span span');
    if (textEl && message) {
      textEl.textContent = message;
    }
  }

  function enableStickyAtcButton() {
    var btn = getStickyAtcButton();
    if (!btn) return;
    btn.disabled = false;
    var textEl = btn.querySelector('.add-to-cart-text__content span span');
    if (textEl) {
      textEl.textContent = 'Add to cart';
    }
  }

  function hasStrapSelected() {
    return selectedStrapVariantId !== null;
  }

  // --- Initial state: disable ATC ---
  var DISABLED_MSG = 'Select a strap to continue';
  disableAtcButton(DISABLED_MSG);
  disableStickyAtcButton(DISABLED_MSG);

  // --- Monkey-patch handleSubmit ---
  productFormComponent.handleSubmit = function (event) {
    event.preventDefault();

    // If the main ATC button is disabled, exit early (matches original behavior)
    var mainBtn = getMainAtcButton();
    if (mainBtn && mainBtn.disabled) return;

    // Validate strap selection
    if (!hasStrapSelected()) {
      if (errorEl) errorEl.style.display = 'flex';
      return;
    }

    // Hide any previous error
    if (errorEl) errorEl.style.display = 'none';

    // Read apron variant ID from the form
    var variantInput = productFormComponent.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;
    var apronVariantId = parseInt(variantInput.value, 10);

    // Read quantity
    var quantityInput = productFormComponent.querySelector('quantity-selector-component input[ref="quantityInput"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    // Generate bundle ID
    var bundleId = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : 'bundle-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);

    // Gather section IDs for cart drawer
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) {
        sectionIds.push(el.dataset.sectionId);
      }
    });

    // Disable buttons during request
    if (mainBtn) mainBtn.disabled = true;
    var stickyBtn = getStickyAtcButton();
    if (stickyBtn) stickyBtn.disabled = true;

    // Build request body
    var body = {
      items: [
        {
          id: apronVariantId,
          quantity: quantity,
          properties: { _bundle_id: bundleId }
        },
        {
          id: parseInt(selectedStrapVariantId, 10),
          quantity: quantity,
          properties: { _bundle_id: bundleId, _bundle_label: 'Strap' }
        }
      ]
    };

    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          // Error from Shopify
          showFormError(response.message || response.description || 'Could not add to cart.');
          if (mainBtn) mainBtn.disabled = false;
          if (stickyBtn) stickyBtn.disabled = false;
          return;
        }

        // Success — animate button
        if (mainBtn) {
          mainBtn.disabled = false;
          mainBtn.dataset.added = 'true';
          setTimeout(function () {
            mainBtn.removeAttribute('data-added');
          }, 800);
        }
        if (stickyBtn) {
          stickyBtn.disabled = false;
          stickyBtn.dataset.added = 'true';
          setTimeout(function () {
            stickyBtn.removeAttribute('data-added');
          }, 800);
        }

        // Dispatch cart:update event so the cart drawer opens
        var formId = productFormComponent.querySelector('form')
          ? productFormComponent.querySelector('form').getAttribute('id') || ''
          : '';

        var cartEvent = new Event('cart:update', { bubbles: true });
        cartEvent.detail = {
          resource: {},
          sourceId: formId,
          data: {
            source: 'product-form-component',
            itemCount: quantity * 2,
            productId: productFormComponent.dataset.productId,
            sections: response.sections || {}
          }
        };
        productFormComponent.dispatchEvent(cartEvent);
      })
      .catch(function (err) {
        console.error('Strap add-to-cart error:', err);
        showFormError('Something went wrong. Please try again.');
        if (mainBtn) mainBtn.disabled = false;
        if (stickyBtn) stickyBtn.disabled = false;
      });
  };

  function showFormError(message) {
    var errorTextEl = productFormComponent.querySelector('.product-form-text__error');
    if (!errorTextEl) return;
    errorTextEl.classList.remove('hidden');
    var textNode = errorTextEl.childNodes[2];
    if (textNode) {
      textNode.textContent = message;
    } else {
      errorTextEl.appendChild(document.createTextNode(message));
    }
    setTimeout(function () {
      errorTextEl.classList.add('hidden');
    }, 10000);
  }

  // --- Strap type selection ---
  var typeCards = selectorRoot.querySelectorAll('.strap-selector__type-card');
  var colorGroups = selectorRoot.querySelectorAll('.strap-selector__colors');

  typeCards.forEach(function (card) {
    card.addEventListener('click', function () {
      var strapProductId = card.dataset.strapProductId;

      // Toggle off if re-clicking same
      if (selectedStrapProductId === strapProductId) return;

      selectedStrapProductId = strapProductId;
      selectedStrapVariantId = null;

      // Highlight selected card
      typeCards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');

      // Show matching color group, hide others
      colorGroups.forEach(function (group) {
        if (group.dataset.strapProductId === strapProductId) {
          group.style.display = '';
          // Clear previously selected swatch in this group
          group.querySelectorAll('.strap-selector__swatch').forEach(function (s) {
            s.classList.remove('is-selected');
          });
        } else {
          group.style.display = 'none';
        }
      });

      // Reset ATC to disabled since color not chosen yet
      disableAtcButton(DISABLED_MSG);
      disableStickyAtcButton(DISABLED_MSG);

      // Hide error
      if (errorEl) errorEl.style.display = 'none';
    });
  });

  // --- Strap color selection ---
  var allSwatches = selectorRoot.querySelectorAll('.strap-selector__swatch');
  allSwatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      if (swatch.disabled) return;

      var variantId = swatch.dataset.variantId;
      var strapProductId = swatch.dataset.strapProductId;
      selectedStrapVariantId = variantId;

      // Highlight within the same strap product group
      selectorRoot
        .querySelectorAll('.strap-selector__swatch[data-strap-product-id="' + strapProductId + '"]')
        .forEach(function (s) { s.classList.remove('is-selected'); });
      swatch.classList.add('is-selected');

      // Update the color name display
      var colorValueEl = selectorRoot.querySelector('.strap-selector__color-value[data-strap-product-id="' + strapProductId + '"]');
      if (colorValueEl) {
        colorValueEl.textContent = swatch.dataset.variantTitle || '';
      }

      // Enable ATC
      enableAtcButton();
      enableStickyAtcButton();

      // Hide error
      if (errorEl) errorEl.style.display = 'none';
    });
  });

  // --- Variant change re-sync ---
  if (sectionEl) {
    sectionEl.addEventListener('variant:update', function () {
      queueMicrotask(function () {
        // Re-apply disabled state if no strap selected
        if (!hasStrapSelected()) {
          disableAtcButton(DISABLED_MSG);
          disableStickyAtcButton(DISABLED_MSG);
        } else {
          // Make sure ATC stays enabled with correct text
          enableAtcButton();
          enableStickyAtcButton();
        }
      });
    });
  }
})();
